// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { IAppEnvironment } from '@core';
import { environmentCommon } from '@environments/environment.common';

const baseUrl = 'https://localhost:6001';
// API GATEWAY
// const baseUrl = 'https://localhost:7001';

export const environment: IAppEnvironment = {
	...environmentCommon,
	local: true,
	apiUrl: `${baseUrl}/api/v1.0`,
	hubBaseUrl: `${baseUrl}/hub`,

	// API GATEWAY
	// apiUrl: `${baseUrl}/api/fo/v1.0`,
	// hubBaseUrl: `${baseUrl}/fo/hub`,
	
	loginUrl: 'https://idp.mycarpa.org/logout',
	logoutUrl: 'https://idp.mycarpa.org/logout',
	returnUrl: 'https://ecarpa.mycarpa.org',
	labFtUrl: 'https://ssl.avocatparis.org/esep/RechercheLCBFT.aspx',

	newVersionCheckIntervalMs: 1 * 60 * 60 * 1000 // every 1 hour
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
